export function getHostname(): string {
  return window.location.hostname;
}
